<template>
  <CRow class="mt-5 pt-5 pb-5">
    <CCol sm="12" class="d-flex flex-column mb-3 p-0">
      <h1 class="titlePage font-weight-normal text-capitalize pb-4">
        {{ $t('templates.email.viewHtmlImport.title') }}
      </h1>
    </CCol>
    <div v-if="loading" style="min-height: 300px" class="d-flex justify-content-center align-items-center dataTable__loading">
      <CSpinner class="my-3" color="primary" />
    </div>

    <CCol v-else sm="12" class="d-flex flex-column mb-5">
      <CRow>
        <CCol sm="12" class="p-0">
          <transition name="fade">
            <MenssageAlert :messages="messages" />
          </transition>
        </CCol>
        <CCol sm="12" class="p-0">
          <CAlert color="success" v-if="template.thumbnail">
            <template #default>
              <div class="d-flex align-items-center p-2">
                <CIcon name="approved" class="alert-success mr-3" size="custom-size" :height="30" viewBox="0 0 32 32" />
                <figure class="image-crop d-flex align-items-center m-0">
                  <img :src="template.thumbnail" :alt="template.name" />
                </figure>
                <h5 class="font-font-weight-normal m-3">
                  {{ $t('templates.email.viewHtmlImport.successfully-submitted') }}
                </h5>
              </div>
            </template>
          </CAlert>
        </CCol>
        <CCol sm="12" class="p-0">
          <p class="pb-2 text-gray-700">
            {{ $t('templates.email.viewHtmlImport.successfully-submitted2') }}
          </p>
        </CCol>
      </CRow>
      <CustomFields class="bg-gray-200 px-4 pt-4" @addCustomFieldsToText="addCustomFieldsToText" @addSubscribeText="addSubscribeText" />
      <EditorHtml
        v-if="template"
        :template="template"
        :subscribeText="subscribeText"
        :customField="customField"
        @confirm="sendTemplete"
        class="pb-5"
      />
    </CCol>
  </CRow>
</template>

<script>
import EditorHtml from '@/components/EditorHtml'
import CustomFields from '@/components/CustomFields'
import MenssageAlert from '@/components/MenssageAlert'
import services from '@/services.js'

const contentTypeEnum = {
  simpleText: 1,
  HTML: 2,
}

export default {
  name: 'ImportHtmlConfirmation',
  components: {
    EditorHtml,
    CustomFields,
    MenssageAlert,
  },
  data() {
    return {
      customField: null,
      subscribeText: '',
      messages: [],
      scrollTopInterval: null,
      template: {
        name: '',
        code: '',
        htmlFileUri: '',
        thumbnailUri: '',
        emailTemplateId: '',
      },
      loading: false,
    }
  },
  created() {
    this.getTemplate()
  },
  methods: {
    async getTemplate() {
      this.messages = []
      this.loading = true
      try {
        let organizationId = this.$store.state.auth.organizationId
        const TEMPLATE_PAYLOAD = await services.getTemplate(organizationId, this.$route.params.id)
        this.template.name = TEMPLATE_PAYLOAD.data.data.name
        this.template.code = TEMPLATE_PAYLOAD.data.data.htmlContent
        this.template.thumbnailUri = TEMPLATE_PAYLOAD.data.data.thumbnailUri
        this.template.htmlFileUri = TEMPLATE_PAYLOAD.data.data.htmlFileUri
        this.template.emailTemplateId = TEMPLATE_PAYLOAD.data.data.emailTemplateId

        this.loading = false
      } catch (error) {
        this.messages.push({
          status: 'danger',
          text: error.response.data.message || 'Error',
        })
      } finally {
        this.loading = false
      }
    },
    addSubscribeText(content) {
      this.subscribeText = ''

      this.$nextTick(() => {
        this.subscribeText = content
      })
    },

    addCustomFieldsToText(content) {
      this.customField = content
    },

    scrollTop() {
      this.scrollTopInterval = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.scrollTopInterval)
        }
        window.scroll(0, window.pageYOffset - 50)
      }, 20)
    },

    sendTemplete(template) {
      this.messages = []
      if (template.isInvalid) {
        this.messages.push({
          status: 'danger',
          text: this.$t('templates.editorHtml.unsubscribe'),
        })
        this.scrollTop()
        return
      }

      this.loading = true
      let organizationId = this.$store.state.auth.organizationId

      services
        .updateTemplateEmail(organizationId, this.$route.params.id, {
          name: this.template.name,
          templateHTMLContent: template.code,
        })
        .then(() => {
          this.loading = false
          this.messages.push({
            status: 'success',
            text: 'Next Step',
          })

          this.$router.push({
            name: 'simple-text',
            params: {
              id: this.$route.params.id,
              contentType: contentTypeEnum.HTML,
              dynamicId: this.$route.params.dynamicId,
              dynamicIndex: this.$route.params.dynamicIndex,
              dynamicDestinationType: this.$route.params.dynamicDestinationType,
            },
          })
        })
        .catch((error) => {
          this.template.code = template.code
          this.messages.push({
            status: 'danger',
            text: error.response.data.message || error.response.data.Message || 'ERROR',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.image-crop {
  overflow: hidden;
  width: 100px;
  height: 100px;
}
</style>
